<div class="drag-area uploader" data-testid="SUBSYS2_ATTACHUPLOADER_BOX" [class.drag-in]="!isImageVisible">
	<h3 class="uploader-title">{{ title() }}</h3>

	@let img = image();
	<div class="uploader-content w-100">

		<ng-content></ng-content>

		@if (isLoading()) {
		<div class="attachment-list">
			<div class="thumbnail">
				<img class="logo-loading" [src]="loaderUrl" alt="loading" data-testid="SUBSYS2_ATTACHLIST_THUMB_LOADER_IMG" />
			</div>
		</div>
		}
		@else if (img) {
		<div class="attachment-list">
			<div data-testid="SUBSYS2_ATTACHLIST_THUMB_BOX" class="thumbnail" [class.border-danger]="isInvalid()"
				[style]="{'background-image': 'url(' + img?.url + ')'}">
				@if (!isDisabled()) {
				<div data-testid="SUBSYS2_ATTACHLIST_THUMB_REMOVE_BTN" class="icon-delete"
					[title]="labels().ATTACHMENT_UPLOADER_COMPONENT_REMOVE_BTN" (click)="removed.emit()"
					(keypress)="removed.emit()">
					<i class="material-icons">delete</i>
				</div>
				<div data-testid="SUBSYS2_ATTACHLIST_THUMB_EDIT_BTN" class="icon-edit" data-toggle="modal"
					[class.bg-danger]="isInvalid()" [class.text-white]="isInvalid()"
					[title]="labels().ATTACHMENT_UPLOADER_COMPONENT_EDIT_BTN" (click)="edited.emit()" (keypress)="edited.emit()">
					<i class="material-icons">edit</i>
				</div>
				}
				<div data-testid="SUBSYS2_ATTACHLIST_THUMB_PREVIEW_BTN" class="icon-zoom" data-toggle="modal"
					[title]="labels().ATTACHMENT_UPLOADER_COMPONENT_PREVIEW_BTN" (click)="zoomed.emit()"
					(keypress)="zoomed.emit()">
					<i class="material-icons">search</i>
				</div>
			</div>
		</div>
		} @else {
		<div class="my-auto">
			<div class="wrapper-actions-panel">
				<i class="material-icons">file_copy</i>
				<i class="material-icons ms-3 me-3">image_search</i>
				<i class="material-icons">photo_size_select_large</i>
			</div>
			<form action="" method="POST" class="d-flex flex-column align-items-center position-relative">
				<h2 data-testid="SUBSYS2_ATTACHUPLOADER_ENABLED_TXT">{{ labels().ATTACHMENT_UPLOADER_COMPONENT_DRAG_MSG }}</h2>
				<input data-testid="SUBSYS2_ATTACHUPLOADER_FILE_BTN" #fileInput type="file" class="bottom-0 w-75"
					(change)="chooseFile($event)" [accept]="validMIMETypes" [disabled]="isUploadDisabled()"
					[class.disabled]="isUploadDisabled()" (click)="isImageChoosing.set(true)"
					(cancel)="isImageChoosing.set(false)">
				<button type="submit" class="w-75" [class.disabled]="isUploadDisabled()">
					{{ labels().ATTACHMENT_UPLOADER_COMPONENT_CHOOSE_MSG }}
				</button>
			</form>
		</div>
		}

	</div>

</div>